import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import AppRoutes from './routes/routes'; 
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store,persistor  } from './store/store';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

const LoadingScreen = () => <div>Loading...</div>;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </PersistGate>     
    </Provider>
    
  
);

reportWebVitals();
